/** Stable IDs are stored on models; names can change without losing links. */
export const FLOW_TAG_NAME_MAX_LENGTH = 80;
export const FLOW_TAG_LIMIT = 100;
export const FLOW_TAG_COLORS = {
  green: { c: "#177E52", bg: "#E4F3EB" },
  red: { c: "#C03D2E", bg: "#FBEAE7" },
  blue: { c: "#2563EB", bg: "#E7EDFB" },
  amber: { c: "#A16207", bg: "#FAF1DD" },
  gray: { c: "#4A4843", bg: "#F2F0EA" },
} as const;
export type FlowTagColor = keyof typeof FLOW_TAG_COLORS;
export type FlowTag = { id: string; name: string; color: FlowTagColor };
/** Existing assignments keep their original server IDs. fresh was an old UI alias. */
export const LEGACY_FLOW_TAGS: FlowTag[] = [
  { id: "focus", name: "фокус", color: "green" },
  { id: "out", name: "на вывод", color: "red" },
  { id: "new", name: "новинка", color: "blue" },
  { id: "promo", name: "акция", color: "amber" },
];
export function canonicalFlowTagId(id: string): string { return id === "fresh" ? "new" : id; }
export function normalizeFlowTagName(raw: unknown): string | null {
  if (typeof raw !== "string" || /[\u0000-\u001f\u007f]/.test(raw)) return null;
  const name = raw.normalize("NFKC").trim().replace(/\s+/g, " ");
  return name && name.length <= FLOW_TAG_NAME_MAX_LENGTH ? name : null;
}
export function flowTagNameKey(name: string): string { return name.toLocaleLowerCase("ru"); }
